/**
 * Display a list of Alias chips.
 */

import React from 'react';

import {Alias, AliasInfo} from './Alias';

type AliasesProps = {
  aliases: AliasInfo[];
};

export const Aliases = ({aliases}: AliasesProps) => {
  // TODO: Sort version first or last?
  return (
    <>
      {aliases.map(a => (
        <Alias key={a.alias} alias={a} />
      ))}
    </>
  );
};
